@if (groups?.length) {
<button type="button"
        (click)="openModal()"
        [attr.aria-label]="'Configure'| translate"
        class="m-t-3 w-12 p-a-3 bg-col-51 p-r-4 p-r-5-s">
    <span class="flex flex-justify-between flex-middle">
        <span class="flex-column left w-11">
            <div style="margin-top: 2px"
                 class="flex flex-column-s flex-column-m">
                <div class="inline-block pos-relative s2 w-12 no-wrap overflow-hidden col-1 m-r-2 ">
                    @switch (!!selection.length) {
                    @case (true){
                    <span class="col-11">Added:&nbsp;</span>
                    @for (product of selectionProducts;let i = $index;let isLast = $last;track trackByProductId(i,
                    product)) {
                    {{product.data.name}} <span class="s2 m-t-1-s m-t-1-m">
                        @if (product.orgPrice){
                        <span class="col-11 line-through">
                            +<price [value]="product.orgPrice"></price>
                        </span>
                        }
                        <span [ngClass]="product.orgPrice ? 'col-2' : 'col-11'">
                            +<price [value]="product.price"></price>
                        </span>@if (!isLast){, }
                    </span>
                    }
                    }
                    @case (false){
                    {{('Would you like to add ' + label + '?')}}
                    }
                    }
                    <div class="pos-absolute z-1 right-0 top-0 bottom-0"
                         style="width:80px;background: linear-gradient(90deg,transparent, #F7F7F7);"></div>
                </div>
            </div>
        </span>
        <i class="icon-plus p-t-1"
           style="font-size: 13px"></i>
    </span>
</button>
}
